import classNames from "classnames/bind";
import { Spinner } from "common/components/Spinner";
import React from "react";
import styles from "./Modal.module.css";
import { Label } from "./forms/Label";

const classNameBuilder = classNames.bind(styles);

export interface Props {
  onClick?: () => void;
  className?: string;
  type?: "inline" | "popup";
  kind?: "tall" | "short";
  loading?: boolean;
  title?: string;
  buttons?: any;
}

export const Modal: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  kind = "short",
  type,
  loading = false,
  title,
  buttons,
}) => {
  const classes = classNameBuilder(className, {
    modal: true,
    tall: kind === "tall",
    short: kind === "short",
    inline: type === "inline",
    popup: type === "popup",
    loading: loading,
  });

  return (
    <section className={classes}>
      <div className={styles.label}>
        <Label htmlFor={""} title={title ? title : ""} />
      </div>
      {loading ? (
        <Spinner color="purple" delay={0} size={25} />
      ) : (
        <>
          <div className={styles.body}>{children}</div>
          {buttons}
        </>
      )}
    </section>
  );
};
